import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vb-payments-annual-minimum',
  templateUrl: './vb-payments-annual-minimum.component.html',
  styleUrls: ['./vb-payments-annual-minimum.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsAnnualMinimumComponent {
  @Input({ required: true }) annualMinimum!: number | null;
  @Input() isEstimated: boolean | null = false;
}
